// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Fxttr","content":"styles_content__1rsoZ","close":"styles_close__3axcB","button":"styles_button__6iyAU"};